<template>
  <div class="activity-goods-page" :style="{ paddingTop: pagePaddingTop }">
    <div class="activity-goods-header" :style="{ top: pagePaddingTop }">
      <input-header
        class="input-header"
        @activitySkuListOptimize="activitySkuListOptimize"
      />
      <search-filter-bar @activitySkuListOptimize="activitySkuListOptimize" />
      <div v-if="showActivityInfo" class="activity-info">
        以下商品
        <span
          v-for="(item, index) in activieInfo"
          :key="index"
          class="text"
          :style="{ color: item.textColor || '#f03100' }"
          >{{ item.tag }}</span
        >
      </div>
    </div>
    <scroll-view
      class="activity-goods-wrapper"
      :style="{ top: paddingTop, height: wrapperHeight }"
      :reach-bottom-loading="loading"
      :finish="isLast && !empty"
      @loadData="loadData"
    >
      <div class="activity-good">
        <new-double-good
          v-for="(item, index) in searchSkuList"
          :key="getGoodComponentKey(item, index)"
          v-recommend-expose="{
            spm: $trackMap.activityGoods.goodExpose,
            params: getTracerParams(item, index)
          }"
          class="activity-good-item"
          :good-width="calcWidth"
          :style="{ width: calcWidth + 'px' }"
          :good="item"
          :sku-index="index"
          :is-small="isSmall"
          @addcart="addCartTrack"
          @subtractcart="subtractCartTrack"
          @click="goDetailTrack"
          @chooseSpec="chooseSpecTrack"
          @popupaddcart="popupAddCartTrack"
          @popupsubtractcart="popupSubtractCartTrack"
        />
      </div>

      <!-- 缺省展示 -->
      <div v-show="empty && isLast" class="empty">
        <img src="@/images/seckill/empty.png" width="40%" />
        <p>抱歉，此分类下没有搜到商品</p>
      </div>
      <cart-float-window />
    </scroll-view>
    <filter-wrap @activitySkuListOptimize="activitySkuListOptimize" />
  </div>
</template>
<script>
import { API } from '@/api'
import { NavBar } from '@mc/mc-jsbridge'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import { mapState, mapActions } from 'vuex'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import ScrollView from '@/common/widgets/scroll_view'
import InputHeader from './components/inputHeader.vue'
import SearchFilterBar from './components/SearchFilterBar.vue'
import FilterWrap from './components/FilterWrap.vue'
import NewDoubleGood from './components/NewDoubleGood.vue'
import { Dialog } from 'vant'
import { APP_CONFIG, THEME_COLOR } from '@/defines/environment/config'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { userInfo } from '@/utils/user'

const RECOMMEND_PAGE_ID = 5256
const RECOMMEND_PAGE_URL = 'https://online.yunshanmeicai.com/new_recommend'
const RECOMMEND_SCENE = '5'

const recommendExpose = {
  inserted(el, binding) {
    const state = { timer: null, observer: null, reported: false }
    const report = () => {
      if (state.reported) return
      state.reported = true
      const value = binding.value || {}
      tracerVuePlugin.request({
        spm: value.spm,
        type: 8,
        event: 1,
        page_id: RECOMMEND_PAGE_ID,
        params: {
          ...(value.params || {}),
          recommended_scene: RECOMMEND_SCENE
        },
        baseData: {
          url: RECOMMEND_PAGE_URL
        }
      })
    }

    if (typeof IntersectionObserver === 'undefined') {
      report()
      return
    }

    state.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const visible = entry.isIntersecting || entry.intersectionRatio > 0
        if (visible && !state.reported) {
          clearTimeout(state.timer)
          state.timer = setTimeout(report, 500)
        } else {
          clearTimeout(state.timer)
          state.timer = null
        }
      })
    }, { threshold: [0] })
    state.observer.observe(el)
    el.__recommendExposeState = state
  },
  unbind(el) {
    const state = el.__recommendExposeState
    if (!state) return
    clearTimeout(state.timer)
    state.observer?.disconnect()
    delete el.__recommendExposeState
  }
}

// 不够一屏，请求下一页面
const NEXT_PAGE_SIZE = 5
export default {
  directives: {
    recommendExpose
  },
  components: {
    CartFloatWindow,
    ScrollView,
    InputHeader,
    SearchFilterBar,
    FilterWrap,
    NewDoubleGood
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '优惠活动'
      const navBar = new NavBar(0)
      navBar.init()
      const promotionId = vm.$route.query.promotion_id
      const promoteRuleId = vm.$route.query.promote_rule_id
      const promoteStageId = vm.$route.query.promote_stage_id
      const promoteType = vm.$route.query.promote_type
      const actionId = vm.$route.query.action_id
      const data = {}
      data.promotionId = (promotionId && Number(promotionId)) || ''
      data.promoteRuleId = (promoteRuleId && Number(promoteRuleId)) || ''
      data.promoteStageId = (promoteStageId && Number(promoteStageId)) || ''
      data.promoteType = (promoteType && Number(promoteType)) || ''
      data.actionId = (actionId && Number(actionId)) || 0
      data.deliveryKey = vm.$route.query?.deliveryKey || ''
      data.filterCart = vm.$route.query?.filterCart || ''
      vm.initData(data)
    })
  },
  data() {
    return {
      activieInfo: [],
      browerInfo: window.matrix,
      isSmall: userInfo.isMemberMall
    }
  },
  onLogin() {
    window.location.reload()
  },
  computed: {
    ...mapState('activityGoods', {
      queryData: state => state.queryData,
      searchSkuList: state => state.searchSkuList,
      isLast: state => state.isLast,
      loading: state => state.loading
    }),
    pagePaddingTop() {
      if (!this.browerInfo.isMiniProgram) {
        return this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    },
    empty() {
      return this.searchSkuList?.length === 0
    },
    showActivityInfo() {
      return this.activieInfo.length > 0
    },
    paddingTop() {
      const paddingTop = 84 + this.statusBarHeight
      const activityHeight = 38
      return this.showActivityInfo
        ? paddingTop + activityHeight + 'px'
        : paddingTop + 'px'
    },
    wrapperHeight() {
      return `calc(100vh - ${this.paddingTop})`
    },
    calcWidth() {
      const baseWidth = window.innerWidth * 2
      return Math.ceil((172 * 2 * baseWidth) / 750 / 2)
    }
  },
  methods: {
    ...mapActions('activityGoods', [
      'classInit',
      'setSkuList',
      'getActivitySkuList',
      'setActQueryData',
      'clearData',
      'clearSkuList',
      'clearStateData'
    ]),
    isMultiSku(good) {
      return (good?.ssuList || []).length > 1
    },
    getGoodComponentKey(good, index) {
      const skuId =
        good?.skuBase?.skuId || good?.skuId || good?.ssuList?.[0]?.sku_id
      const componentType = this.isMultiSku(good) ? 'multi' : 'single'
      return `${skuId || index}-${componentType}`
    },
    getTracerParams(good, skuPos, ssu, ssuPos = 0) {
      const currentSsu = ssu || (this.isMultiSku(good) ? null : good?.ssuInfo)
      const fallbackSsu = currentSsu || good?.ssuInfo
      return {
        sku_id: currentSsu?.sku_id || good?.skuBase?.skuId || 0,
        ssu_id: currentSsu?.ssuId || 0,
        sku_pos: skuPos,
        price: currentSsu?.priceSpm || good?.priceSpm || '',
        ssu_pos: ssu ? ssuPos : 0,
        keyword: '',
        recommended_scene: RECOMMEND_SCENE,
        activity_id: String(fallbackSsu?.ssuSpm?.bigActivityId || '') || '',
        goods_status:
          fallbackSsu?.statusInfo?.status ||
          fallbackSsu?.status_remind_info?.goods_status ||
          0,
        ...good?.extraTrack,
        ...fallbackSsu?.extraTrack,
        type_of_url: String(good?.skuImg?.videoFlag || '1')
      }
    },
    reportRecommend(spm, params) {
      tracerVuePlugin.request({
        spm,
        type: 2,
        event: 1,
        page_id: RECOMMEND_PAGE_ID,
        params: {
          ...params,
          recommended_scene: RECOMMEND_SCENE
        },
        baseData: {
          url: RECOMMEND_PAGE_URL
        }
      })
    },
    addCartTrack(ssu, skuIndex) {
      this.reportRecommend(this.$trackMap.activityGoods.plusCar, this.getTracerParams(ssu, skuIndex))
    },
    subtractCartTrack(ssu, skuIndex) {
      this.reportRecommend(this.$trackMap.activityGoods.minusCar, this.getTracerParams(ssu, skuIndex))
    },
    chooseSpecTrack(good, skuIndex) {
      this.reportRecommend(
        this.$trackMap.activityGoods.chooseFormate,
        this.getTracerParams(good, skuIndex)
      )
    },
    popupAddCartTrack({ good, ssu, skuIndex, ssuIndex }) {
      this.reportRecommend(
        this.$trackMap.activityGoods.plusCarModal,
        this.getTracerParams(good, skuIndex, ssu, ssuIndex)
      )
    },
    popupSubtractCartTrack({ good, ssu, skuIndex, ssuIndex }) {
      this.reportRecommend(
        this.$trackMap.activityGoods.minusCarModal,
        this.getTracerParams(good, skuIndex, ssu, ssuIndex)
      )
    },
    goDetailTrack(ssu, skuIndex) {
      this.reportRecommend(this.$trackMap.activityGoods.goDetail, this.getTracerParams(ssu, skuIndex))
    },
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    },
    async initData(data) {
      this.clearSkuList()
      try {
        await userInfo.getcompany()
      } catch (e) {}
      this.isSmall = userInfo.isMemberMall
      if (data.deliveryKey) {
        this.setQueryData('deliveryKey', data.deliveryKey)
      }
      if (data.promotionId) {
        this.setQueryData('filterCart', data.filterCart)
      }
      if (data.promotionId) {
        this.setQueryData('promotionId', data.promotionId)
      }
      if (data.promoteRuleId) {
        this.setQueryData('promoteRuleId', data.promoteRuleId)
      }
      if (data.promoteStageId) {
        this.setQueryData('promoteStageId', data.promoteStageId)
      }
      if (data.promoteType) {
        this.setQueryData('promoteType', data.promoteType)
      }
      this.setQueryData('actionId', data.actionId)

      const isGetActivityInfo = data.promotionId && data.promoteType
      if (isGetActivityInfo) {
        const activieInfo = (await API.activity.getActivityInfo(data)) || []
        this.activieInfo = activieInfo
      } else {
        this.activieInfo = []
      }

      const saleClass = await API.activity.polymerizeSaleClass(data)
      this.classInit(saleClass)
      this.activitySkuListOptimize(data).then(res => {
        const isSkipToOtherPage = res.isSkipToOtherPage
        if (isSkipToOtherPage) {
          Dialog.alert({
            message: `欢迎到${APP_CONFIG.app_name}下单`,
            confirmButtonText: '去凑单',
            confirmButtonColor: THEME_COLOR
          }).then(() => {
            this.goMall()
          })
        }
      })
    },
    goMall() {
      nativeRedirect(nativeRoutes.goodsList)
    },
    // 滚动加载
    loadData() {
      if (this.loading || this.isLast) return
      if (!this.isLast) {
        this.activitySkuListOptimize()
      }
    },

    async activitySkuListOptimize() {
      try {
        const page = this.queryData.page + 1
        this.setQueryData('page', page)
        const resultData = (await this.getActivitySkuList(this.queryData)) || []
        let resultSkuList = resultData?.skuList
        let isLast = !!resultData.isLast
        let brandList = resultData.brandList
        let filterList = resultData.biList
        while (!isLast && resultSkuList?.length < NEXT_PAGE_SIZE) {
          const page = this.queryData.page + 1
          this.setQueryData('page', page)
          const nextResultData = await this.getActivitySkuList(this.queryData)
          // 如果无网状态下则返回 null，此时不在请求
          if (nextResultData === null) break
          isLast = nextResultData?.isLast
          const nexSkuList = nextResultData?.skuList
          isLast = nextResultData?.isLast
          brandList = nextResultData?.brandList
          filterList = nextResultData?.biList
          resultSkuList = [...resultSkuList, ...nexSkuList]
        }
        resultData.skuList = resultSkuList
        resultData.isLast = isLast
        resultData.brandList = brandList
        resultData.filterList = filterList
        return resultData
      } catch (e) {
        this.$catch(e)
        this.setSkuList({
          skuList: [],
          isLast: true,
          brandList: [],
          biList: []
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-goods-page {
  height: 100vh;

  overflow-x: hidden;

  background-color: #fff;
  .activity-goods-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    width: 100%;

    overflow-x: hidden;

    padding: 8px 0.2rem 0;

    background-color: #f5f5f5;

    .activity-good {
      @include flex(row, space-between, flex-start, wrap);
    }

    ::v-deep .activity-good-item {
      margin-bottom: 0.12rem;
    }
  }
  .activity-goods-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 6;

    background-color: #f5f5f5;
  }
  .activity-info {
    width: 100%;
    height: 38px;
    padding: 0.24rem;

    background-color: #fdede9;
    border-radius: 0 0 16px 16px;
    box-sizing: border-box;

    @include text(0.26rem, #222);
    @include flex-row-center;
    @include text-overflow-ellipsis-single;
    .text {
      color: #f03100;
    }
  }

  .empty {
    display: flex;

    padding-top: 50px;

    flex-direction: column;
    align-items: center;

    & > p {
      margin-top: 20px;

      font-size: 0.24rem;
      color: #666;
    }
  }
}
</style>
